import { render, staticRenderFns } from "./OfflinePayment.vue?vue&type=template&id=06d640e8&scoped=true&"
import script from "./OfflinePayment.vue?vue&type=script&lang=js&"
export * from "./OfflinePayment.vue?vue&type=script&lang=js&"
import style0 from "./OfflinePayment.vue?vue&type=style&index=0&id=06d640e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d640e8",
  null
  
)

export default component.exports